import React from 'react';

interface TrendingTokenIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const TrendingTokenIcon: React.FC<TrendingTokenIconProps> = ({
  width = 20,
  height = 20,
  fill = 'currentColor',
  className = ''
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.99996 18.2008C9.59996 18.2008 9.21996 18.0208 8.95996 17.7208L1.03996 9.34078C0.619962 8.86078 0.539962 8.14078 0.839962 7.56078L3.51996 2.58078C3.77996 2.10078 4.25996 1.80078 4.77996 1.80078H15.24C15.76 1.80078 16.24 2.10078 16.5 2.58078L19.18 7.56078C19.48 8.14078 19.42 8.86078 18.98 9.34078L18.96 9.36078L11.04 17.7208C10.78 18.0208 10.4 18.2008 9.99996 18.2008ZM2.25996 8.30078L9.99996 16.5008L17.74 8.30078L15.12 3.40078H4.87996L2.25996 8.30078Z"
        fill={fill}
      />
      <path
        d="M1.16003 7.59961H18.8V9.19961H1.16003V7.59961Z"
        fill={fill}
      />
      <path
        d="M14.24 9.17918H5.69995L8.75995 2.89918L8.81995 2.81918C9.11995 2.43918 9.55995 2.23918 10.04 2.25918C10.52 2.27918 10.96 2.49918 11.24 2.87918L11.28 2.93918L14.24 9.17918ZM8.25995 7.57918H11.72L9.99995 3.99918L8.25995 7.57918Z"
        fill={fill}
      />
      <path
        d="M9.97999 17.0991C9.95999 17.0991 9.95999 17.0991 9.97999 17.0991C9.55999 17.0991 9.19999 16.8391 9.05999 16.4591L6.23999 8.65914L7.73999 8.11914L9.97999 14.3191L12.24 8.11914L13.74 8.65914L10.9 16.4591C10.76 16.8391 10.38 17.0991 9.97999 17.0991Z"
        fill={fill}
      />
    </svg>
  );
};

export default TrendingTokenIcon;
